<template>
    <div> 
        <base-header type="" class="rsgradient pb-3 pb-1 pt-3 pt-md-5">
        </base-header>
         <b-card style="margin: 20px">
             <b-card-header header-tag="header" class="p-1" role="tab">Mi Tarjeta MasterCard
             </b-card-header>
            <b-card-body v-if="!model.viewResult">
                <div class="row form-group">
                    <div class="col-md-12 text-center">
                        <label>Obtener tu tarjeta prepaga internacional ahora es Resimple y accedé a los comercios y servicios de todo el mundo.</label> 
                    </div>
                </div>   
                <div class="text-center" style="margin-top: 10px">
                    <img src="@/assets/card_landing.png" class="mx-auto d-block" width="40%" height="40%" />
                </div>
                <div class="row form-group" >
                    <div class="col-md-12 text-center">
                        <save-button text="Solicitar mi tarjeta" @click="solicitarMiTarjeta"></save-button>
                    </div>
                </div>
            </b-card-body>

             <!-- Pagina con Alerta si no esta habilitado para operar con Mastercard -->
            <b-card-body v-if="model.viewResult">
                <div class="row">
                    <div class="col-md-12 text-center">
                        <base-alert :type="resultado.Tipo">
                        <span class="alert-inner--icon" style="font-size: 60px;">
                            <i :class="resultado.Icono"></i>
                        </span><br>
                        <span class="alert-inner--text" v-html="resultado.Texto"></span>
                        </base-alert>
                    </div>
                    <div class="col-md-12">
                        <div class="row text-center" style="margin-top: 10px">
                            <div class="col-md-12">
                                <b-button class="btn btn-lg btn-danger" @click="goBack">Volver</b-button>
                            </div>
                        </div>
                    </div>
                </div>
            </b-card-body>
        </b-card> 
    </div>
</template>

<style>
</style>

<script>
    import Vue from 'vue'
    import vSelect from 'vue-select'
    Vue.component('v-select', vSelect)
    import 'vue-select/dist/vue-select.css';
    import axiosHelpers from '@/helpers/axiosHelpers';
    import notificationHelpers from '@/helpers/notificationHelpers';

    export default {
        components: { 
        },
        props: {
            requestAgain: Boolean
        },
        data(){
            return{
                model: {   
                    RequestAgain: this.requestAgain,
                    viewResult: false      
                },
                resultado: { Icono: "", Texto: "", Tipo: "" }
            }
        },
        methods: {
            solicitarMiTarjeta() {
                let context = this
                let req = { AccountID: context.$store.getters.accountID };

                axiosHelpers.axiosPost('Mastercard/ValidateAccountLevelToRequestMastercardCard', req, this, function(data){ 
                    // -- Si esta apto, redireccionamos a (RequestMyCard)
                    if(data.ResponseVM.Result)
                    {
                       context.$router.push("RequestMyCard");                       
                    }
                    else
                    {
                        // -- Redirecciamos a Validar Identidad
                        if(!data.ResponseVM.IdentityValidated)
                        {
                            context.$router.push("verificacionidentidad");
                        }
                        // -- Redireccionar a Validar Info Renaper
                        else if(!data.ResponseVM.RenaperValidated)
                        {
                            context.$router.push("RenaperInfo");
                        }
                    }
                });
            },
            goBack() {
                this.$router.go(-1);
            },
            getData() {
               let context = this
               let req = { AccountID: context.$store.getters.accountID };

                axiosHelpers.axiosPost('Mastercard/ValidateCardRequestState', req, this, function(data){                            
                    
                    // -- Viene de Solicitar una Nueva
                    if(!context.model.RequestAgain)
                    {
                         // -- Si el resultado es 'true', significa que tiene una solicitud
                        if(data.ResponseVM.Result)
                        {
                            context.model.viewResult = true;
                            // -- Si tiene la Cuenta deshabilitada, redireccionamos 'MastercardAccountDisable'
                            if(data.ResponseVM.IsMastercardAccountDisable)
                            {
                                context.$router.push("MastercardAccountDisable");
                            }
                            // -- Si tiene la Tarjeta activada, redireccionamos la billetera de la Tarjeta
                            else if(data.ResponseVM.IsCardActivated)
                            {
                                context.$router.push("MyMastercardWallet");
                            }                         
                            // -- Si tiene la Tarjeta en Reimpresion
                            else if(data.ResponseVM.IsReprint)
                            {
                                context.$router.push({ name: "MyMastercardWallet", params: { IsReprint: true, StateID: data.ResponseVM.RequestState }});
                            }
                            // -- Mostramos la Solicitud de Tarjeta, segun el estado que este la misma
                            else
                            {
                                // -- Pendiente de Verificacion
                                if(data.ResponseVM.RequestState == context.$store.getters.MastercardPendienteDeVerificacion)
                                {
                                    context.$router.push({ name: "CardRequestGenerated", params: { welcomeMessage: data.ResponseVM.WelcomeMessage }});
                                }
                                // -- Aprobado
                                else if(data.ResponseVM.RequestState == context.$store.getters.MastercardAprobado)
                                {
                                    context.$router.push("CardGenerationRequestApproved");
                                }
                                // -- Rechazado
                                else if(data.ResponseVM.RequestState == context.$store.getters.MastercardRechazado)
                                {
                                    context.$router.push({name:"card generation request refused", params:{reason:data.ResponseVM.Reason}});
                                }
                                 // -- Impresa, En camino, Entregada
                                else
                                {
                                    context.$router.push({ name: "ApprovedCardTracking", params: { welcomeMessage: data.ResponseVM.WelcomeMessage, requestState: data.ResponseVM.RequestState }});
                                }
                            }
                        }
                        else 
                        {
                            // -- Si tiene alertas
                            if(data.Alerts != null && data.Alerts.length > 0)
                            {
                                context.model.viewResult = true;
                                context.resultado = {
                                    Texto: data.Alerts[0].Message,
                                    Tipo: "warning",
                                    Icono: "fa fa-fw fa-clock"
                                };
                            }
                            // -- Operador Deshabilitado
                            else if(data.ResponseVM.OperatorDisabled)
                            {
                                context.$router.push("MiTarjetaPrepaga");
                            }
                        }
                    }
                });
            },      
        },
        mounted() {
            this.getData();
        }
    }
</script>